export enum ListingDepositMethod {
  /**
   * 按固定值收取保证金
   */
  FIXED = 0,
  /**
   * 按成交额比例收取保证金
   */
  PROPORTIONA = 1
}

export const ListingDepositMethodTextMap: Record<ListingDepositMethod, string> =
  {
    [ListingDepositMethod.FIXED]: '按固定值收取保证金',
    [ListingDepositMethod.PROPORTIONA]: '按成交额比例收取保证金'
  }

export const ListingDepositMethodUnitMap: Record<ListingDepositMethod, string> =
  {
    [ListingDepositMethod.FIXED]: '元',
    [ListingDepositMethod.PROPORTIONA]: '%'
  }
